import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTicket } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../../components/Ui_Element/Breadcrumb";
import DepartmentTaskAnalyticsPage from "./DepartmentTaskAnalyticsPage";
import CustomerTicketAnalyticsPage from "./CustomerTicketAnalyticsPage";

const BRAND_135 = "linear-gradient(135deg, #C04C2A 0%, #8B2A15 55%, #4A1B13 100%)";

const TABS = [
  { key: "department", label: "Department Task Analytics", icon: faBuilding },
  { key: "customer",   label: "Customer Ticket Analytics", icon: faTicket },
];

export default function AdminAnalyticsDashboardPage() {
  const [activeTab, setActiveTab] = useState("department");

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50 dark:bg-none dark:bg-[#0F111A] p-2 transition-colors duration-300 sm:p-3 md:p-5">
      <Breadcrumb pageName="Admin Analytics Dashboard" currentPage="Admin Analytics Dashboard" />

      {/* ── Tab Bar ── */}
      <div className="mt-4 grid grid-cols-1 gap-2 rounded-2xl border border-orange-100 bg-white p-2 shadow-sm dark:border-gray-800 dark:bg-[#161B22] sm:flex sm:flex-wrap" style={{ boxShadow: "0 8px 24px rgba(192,76,42,0.08)" }}>
        {TABS.map((tab) => {
          const active = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className="inline-flex min-w-0 items-center justify-center gap-2 rounded-xl px-3 py-2.5 text-xs font-bold transition dark:text-gray-400 sm:flex-none sm:px-4 sm:text-sm"
              style={
                active
                  ? { background: BRAND_135, color: "#fff", boxShadow: "0 4px 14px rgba(192,76,42,0.30)" }
                  : { background: "transparent", color: "" }
              }
              onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = "rgba(192,76,42,0.06)"; }}
              onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
            >
              <FontAwesomeIcon icon={tab.icon} className="shrink-0" />
              <span className="min-w-0 truncate">{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* ── Active Tab Content ── */}
      {activeTab === "department" ? (
        <DepartmentTaskAnalyticsPage embedded />
      ) : (
        <CustomerTicketAnalyticsPage embedded />
      )}
    </div>
  );
}
